import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Tabs, Tab } from "@mui/material";
import {
  findGetParameter,
  getData,
  newPath,
} from "../../components/utilities/UtilityFunctions";

import { postNotification } from "../../components/utilities/Notifications";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { handlePagingAll } from "../../components/api/APIUtilities";

import CircuitDetails from "./components/CircuitDetails";
import CircuitTokens from "./components/CircuitTokens";
import CircuitWidgets from "./components/CircuitWidgets";
import { BCPShop } from "../../components/icons/bcp/BCPIcons";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`circuit-tabpanel-${index}`}
      aria-labelledby={`circuit-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

function a11yProps(index) {
  return {
    id: `circuit-tab-${index}`,
    "aria-controls": `circuit-tabpanel-${index}`,
  };
}

const tabIndexes = {
  details: 0,
  tokens: 1,
  widgets: 2,
};

export default function CircuitOrganize(props) {
  let { leagueId } = useParams();
  const { setItemsMiddle } = props;
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [circuit, setCircuit] = useState(null);

  const activeTabParam = findGetParameter("active_tab");

  const [activeTab, setActiveTab] = useState(
    activeTabParam
      ? tabIndexes[activeTabParam.toLowerCase()] !== undefined
        ? tabIndexes[activeTabParam.toLowerCase()]
        : 0
      : 0
  );

  const getCircuit = async (circuitId, authContext, options) => {
    var apiCircuit = await getData(`/leagues/${circuitId}`, {
      queryStringParameters: {
        "expand[]": ["gameSystem", "gameStore"],
      },
    });

    if (
      apiCircuit?.gameStore?.ownerId &&
      apiCircuit.gameStore.ownerId !== authContext?.authState?.identity?.userId
    ) {
      var storeUser = await handlePagingAll(`/gamestoreusers`, {
        limit: 100,
        gameStoreId: apiCircuit?.gameStore.id,
        userId: authContext?.authState?.identity?.userId,
      });
      apiCircuit.myStoreUser = storeUser?.length > 0 ? storeUser[0] : null;
    }

    const fetchFile = async (fileId) => {
      if (!fileId) return;

      var returnObj;
      try {
        returnObj = await getData(`/files/${fileId}`, {
          queryStringParameters: {},
        });
      } catch (err) {
        console.error(err);
      }
      return returnObj;
    };

    async function parallel() {
      const taskPhoto = options?.photo
        ? fetchFile(apiCircuit.photoFileId)
        : null;

      return {
        photo: await taskPhoto,
      };
    }

    var parallelData = await parallel();
    apiCircuit.photo = parallelData.photo;

    return apiCircuit;
  };

  const handleTabChange = async (e, newTab, freshEvent) => {
    setLoading(true);
    try {
    } catch (err) {
      setLoading(false);
      return;
    }

    var path;
    Object.keys(tabIndexes).forEach((tabIndex) => {
      if (tabIndexes[tabIndex] === newTab) {
        path = newPath({
          active_tab: tabIndex,
        });

        return true;
      }
    });
    setActiveTab(newTab);
    navigate(path, { replace: false });
    setLoading(false);
  };

  useEffect(() => {
    const check = async () => {
      setLoading(true);
      try {
        if (leagueId) {
          var apiCircuit = await getCircuit(leagueId, authContext, {
            photo: activeTab === 0,
          });
          if (apiCircuit?.gameStore) {
            updateMenuItems(setItemsMiddle, apiCircuit.gameStore);
          }
          setCircuit(apiCircuit);
        } else {
          setCircuit({});
        }
      } catch (err) {
        postNotification("error", err);
        navigate("/");
        return;
      }
      setLoading(false);
    };
    check();
    // eslint-disable-next-line
  }, [activeTab]);

  return (
    <>
      {Boolean(loading) && <ModalLoadingFull />}
      {circuit && (
        <Box sx={{ width: "100%" }}>
          <TabPanel value={activeTab} index={0}>
            <CircuitDetails
              circuit={circuit}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              handleTabChange={handleTabChange}
              authContext={authContext}
              setItemsMiddle={setItemsMiddle}
            />
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            <CircuitTokens
              circuit={circuit}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              handleTabChange={handleTabChange}
              authContext={authContext}
            />
          </TabPanel>
          <TabPanel value={activeTab} index={2}>
            <CircuitWidgets
              circuit={circuit}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              handleTabChange={handleTabChange}
              authContext={authContext}
            />
          </TabPanel>
        </Box>
      )}
    </>
  );
}

export function CircuitTabs(props) {
  const { circuit, activeTab, authContext, handleTabChange } = props;

  return (
    <Box
      sx={{
        maxWidth: "100%",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        // allowScrollButtonsMobile
        aria-label="circuit tabs"
      >
        <Tab
          label="Details"
          {...a11yProps(0)}
          disabled={
            authContext?.authState?.identity?.isAdmin !== true &&
            !circuit?.myStoreUser?.createLeagues &&
            circuit?.gameStore?.ownerId !==
              authContext?.authState?.identity?.userId &&
            !authContext?.authState?.identity?.adminGameSystems?.includes(
              circuit?.gameSystemId
            )
          }
        />
        {circuit?.id && (
          <Tab
            label="Tokens"
            {...a11yProps(1)}
            disabled={
              authContext?.authState?.identity?.isAdmin !== true &&
              !circuit?.myStoreUser?.approveTokens &&
              circuit?.gameStore?.ownerId !==
                authContext?.authState?.identity?.userId &&
              !authContext?.authState?.identity?.adminGameSystems?.includes(
                circuit?.gameSystemId
              )
            }
          />
        )}
        {circuit?.id && <Tab label="Widgets" {...a11yProps(2)} />}
      </Tabs>
    </Box>
  );
}

export async function hasAccess(circuit, authContext, tabIndex, notify) {
  var err;

  if (
    authContext?.authState?.identity?.isAdmin === true ||
    authContext?.authState?.identity?.adminGameSystems?.includes(
      circuit?.gameSystemId
    )
  ) {
    return true;
  }

  if (tabIndex === 0) {
    return true;
  }

  if (circuit) {
    if (
      circuit.gameStore?.ownerId &&
      authContext?.authState?.identity?.userId === circuit.gameStore?.ownerId
    ) {
      // is Store Owner
      return true;
    }
    if (circuit.myStoreUser) {
      if (tabIndex === 0) {
        if (circuit.myStoreUser.createLeagues) {
          return true;
        }
      }
      if (tabIndex === 1) {
        if (circuit.myStoreUser.approveTokens) {
          return true;
        }
      }
    }
  } else {
    // new store
    // do we need to limit this access here?
    return true;
  }

  err = new Error(
    "You do not have access to this function for this Organization"
  );
  if (notify) postNotification("warning", err);

  if (err) {
    throw err;
  }
  return false;
}

export function updateMenuItems(setItemsMiddle, organization) {
  if (!setItemsMiddle || !organization) {
    return;
  }
  var middleArray = [
    {
      href: `/organize/organization/${organization.id}?active_tab=circuits`,
      icon: BCPShop,
      title: organization.name || "Organization",
    },
  ];
  setItemsMiddle(middleArray);
}
